export default __webpack_public_path__ + "static/media/dollar-bag.c17cb743.png";